import { Component, OnInit, ViewChild, AfterViewInit, HostListener, Renderer2, ElementRef } from "@angular/core";
import { Observable } from "rxjs";
import { UserService } from "../../services/user.service";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { PipeTransform } from "@angular/core";
import moment from "moment-timezone";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { LoaderModalService } from "../../services/loader.service";
import { CartlengthService } from "../../services/cartlength.service";
import { AppStateService } from "src/app/shared/app-state.service";
import { CommonService } from "src/app/services/common.service";
import { BehaviorService } from "src/app/services/behaviour.service";
declare var $: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit, AfterViewInit, PipeTransform {
  @ViewChild("dynamicPlaceholder", { static: true }) input: ElementRef;
  storeList$: Observable<any>;
  auth: any;
  storeAddresss: any;
  isSideNav: boolean = false;
  mySubscription: any;
  promo: FormGroup;
  subCategoryMobile: any = [];
  subscriptions: any = [];
  topSearchArray: any = [];
  CartBarLimitFlower: any = 0;
  isStoreHours: any = "Pickup";
  storeId: any;
  categoryList: any = [];
  storeName: any;
  marqueeText: any = [];
  cartLength = 0;
  CategoryId: any;
  cartProduct$: any;
  subCategoryId: any;
  cartSum: any;
  userName: string;
  quantity = [];
  categoryName = "";
  lat: any;
  lng: any;
  sideMenu: any;
  defaultUrl =
    "https://ams.iqmetrix.net/images/e02aa3c7-9b73-4153-b16b-5e8ab6ab1b2d";

  addressStreetNumber: any;
  addressPostalCode: any;
  addressRoute: any;
  addressLocality: any;
  addressAdministrationLevel: any;
  addressCountry: any;
  addressNeighborhood: any;
  addressCurrentLat: any;
  addressCurrentLong: any;
  addressFormattedAddress: any;
  addressSubLocality = "";
  governmentIDStatus = "";
  governmentIDMessage = "";
  cartMessageError = "";
  checkOutCartMessage = "";
  jun = moment();
  torrontoTime: any;
  est24Hours: any;
  currentHourMin: any;
  addressData: any;
  storeTiming: any;
  hideCartOption = true;
  timeSlotEnd = "";
  offlineCartProduct = [];
  addressString = "";
  spinnerForm: FormGroup;
  spinData = [];
  activeSpin = false;
  currentUrl = "";
  searchInput = "";
  isSearchShow: boolean = false;
  hideCloseBtn = false;
  storeMobile = "6477252779";
  PickUpData;
  userId: string;
  addressCountryCode: string;
  status: any;
  formattedAddress: any[];
  pickupAddress: any;
  addressState: string;
  addressCity: string;
  selectedStoreName: any;
  storeDetails: any;
  addressStatus: string;
  postalCode: string;
  city: string;
  state: string;
  mobile: string;
  email: string;
  mobileNumber = "";
  step: number;
  subCategoryName: any;
  selectedDate: any;
  subCatList: any[];
  slotColor = "#000";
  suggestionSearchList: any[];
  siteDada: any;
  newStoreHandle;
  qtyValue;
  StoreClosed;
  progressbarWidth;
  isPickup;
  guestProgressbarWidth;
  showLoading;
  COLOR;
  weekday;
  storeImage: any = "";
  showScroll: boolean;
  showScrollHeight = 200;
  hideScrollHeight = 200;

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private commonService: CommonService,
    private userSrv: UserService,
    private router: Router,
    private loaderSrv: LoaderModalService,
    private cartLengthService: CartlengthService,
    private bs: BehaviorService,
    private appStateSvc: AppStateService,
  ) {
    this.getSideNavCOntent();

    setTimeout(() => {
      this.siteDada = JSON.parse(localStorage.getItem("siteData"));
    }, 300);
    let siteDada = JSON.parse(localStorage.getItem("siteData"));
    if (siteDada != undefined && siteDada != null && siteDada != "") {
      this.siteDada = siteDada;
    }
  }
  updateCartCount(newCount: number) {
    localStorage.setItem("loggedInCart", String(newCount));
    this.cartLengthService.cartLengthUpdate.emit(newCount); // ✅ Emit updated cart count
  }

  createForm() {
    this.promo = this.fb.group({
      permo: ["", Validators.required],
    });
  }

  transform(username: string, args: any[]): string {
    return username.split("")[0];
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) > this.showScrollHeight
    ) {
      this.showScroll = true;
    } else if (
      this.showScroll &&
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) < this.hideScrollHeight
    ) {
      this.showScroll = false;
    }
  }

  ngOnInit(): void {
    this.categoryList = this.appStateSvc.stateData.categoryList;
    this.marqueeText = this.appStateSvc.stateData.marqueeText;
    if (this.marqueeText?.length < 1) {
      this.getMarqueeData();
    }
    this.getSuggestionSearchList();
    if (!this.categoryList || this.categoryList?.length < 1) {
      this.commonService.getCategoryList().subscribe((res: any) => {
        this.categoryList = res.data;
        this.appStateSvc.setState({
          categoryList: this.categoryList,
        });
      });
    }

    if (this.cartLengthService.subsVar == undefined) {
      this.cartLengthService.subsVar =
        this.cartLengthService.cartLengthUpdate.subscribe((value: Number) => {
          this.cartLengthUpdate(value);
        });
    } else {
      this.cartLengthService.subsVar =
        this.cartLengthService.cartLengthUpdate.subscribe((value: Number) => {
          this.cartLengthUpdate(value);
        });
    }

    this.isPickup = JSON.parse(localStorage.getItem("isPickUpOrder"));
    this.CartBarLimit = Number(localStorage.getItem("CartBarLimit"));
    this.weekday = new Date().toLocaleString("en-us", { weekday: "long" });
    this.getStoreList();
    if (
      localStorage.getItem("addressStatus") === undefined ||
      localStorage.getItem("addressStatus") === null
    ) {
      $("#selectOrderStatusPopup").modal("show");
      return;
    } else {
      this.COLOR = "";
      this.showLoading = false;

      this.guestCartWeight = 0;
      this.isPickup = JSON.parse(localStorage.getItem("isPickUpOrder"));
      this.progressbarWidth = "25%";
      this.guestProgressbarWidth = "0%";
      this.defaultUrl = "assets/images/defaultimg.jpeg"; //default image

      this.qtyValue = 1;
      this.isPickup = localStorage.getItem("isPickUpOrder");

      let store = JSON.parse(localStorage.getItem("storeInfo"));
      this.storeImage = store?.image;
      this.storeAddresss = store?.Address?.AddressLine2
        ? store?.Address?.AddressLine2
        : store?.addressLine2;
      this.StoreClosed = false;
      this.userName = localStorage.getItem("userName");
      this.checkSpinTheWheelShow(this.router.url);
      //store details
      this.getStoreDetail();

      if (
        localStorage.getItem("addressString") === undefined ||
        localStorage.getItem("addressString") === null
      ) {
        this.hideCloseBtn = false;
      } else {
        this.hideCloseBtn = true;
      }
      if (
        localStorage.getItem("isPickUpOrder") === undefined ||
        localStorage.getItem("isPickUpOrder") === null
      ) {
        $("#selectOrderStatusPopup").modal("show");
      } else {
        if (
          localStorage.getItem("addressStatus") === undefined ||
          localStorage.getItem("addressStatus") === null
        ) {
          $("#SearchLocation").modal("show");
          this.isPickup = localStorage.getItem("isPickUpOrder");
        }
      }

      $(window).on("scroll", function () {
        let top = $(window).scrollTop();
        if (top >= 30) {
          $(".sticky-header").addClass("fixed");
          $(".select-address-header").addClass("fixed");
        } else {
          $(".sticky-header").removeClass("fixed");
          $(".select-address-header").removeClass("fixed");
        }
      });
      this.CartBarLimit = Number(localStorage.getItem("CartBarLimit"));
      this.CartBarLimitFlower = Number(
        localStorage.getItem("CartBarLimitFlower"),
      );
      this.weekday = new Date().toLocaleString("en-us", { weekday: "long" });
      this.commonService.getPurchasaeLimit().subscribe((res) => {
        if (res["meta"]["status"]) {
          if (res["data"]["limitvalue"]) {
            this.CartBarLimit = Number(res["data"]["limitvalue"]);
            localStorage.setItem("CartBarLimit", this.CartBarLimit);
          }
          if (res["data"]["flowerLimitValue"]) {
            this.CartBarLimitFlower = Number(res["data"]["flowerLimitValue"]);
            localStorage.setItem("CartBarLimitFlower", this.CartBarLimitFlower);
          }
        }
      });

      this.checkValueInSearch();
      this.createSpinnerForm();
      this.createForm();
      this.addressString = localStorage.getItem("addressString");
      if (
        localStorage.getItem("localStoreId") === null ||
        localStorage.getItem("localStoreId") === undefined
      ) {
        if (
          localStorage.getItem("isPickUpOrder") === undefined ||
          localStorage.getItem("isPickUpOrder") === null
        ) {
          $("#selectOrderStatusPopup").modal("show");
        } else {
          if (
            localStorage.getItem("addressStatus") === undefined ||
            localStorage.getItem("addressStatus") === null
          ) {
            $("#SearchLocation").modal("show");
          }
        }
      } else {
        let obj = {
          storeId: Number(localStorage.getItem("localStoreId")),
          storeName: localStorage.getItem("localStoreName"),
          storeEmail: localStorage.getItem("storeEmail"),
        };
        this.storeId = Number(localStorage.getItem("localStoreId"));
        this.storeName = localStorage.getItem("localStoreName");

        this.storeMobile = localStorage.getItem("storeMobile");
        this.userSrv.updateStoreDetails(obj);
      }
      this.mySubscription = this.userSrv.getAuth().subscribe((res) => {
        //logeed in user
        this.auth = res;
        if (this.auth) {
          this.addOfflineProductToCart();
          this.userName = localStorage.getItem("userName");
        }
        this.checkUserEmailIDStatus();
        this.getAddress();
        if (res) {
        }
        if (localStorage.getItem("addressData") !== null) {
          this.saveUserAddressAfterLogin();
        }
        this.commonService.emitCartData().subscribe((data) => {
          if (this.auth) {
            this.getCartProduct();
          } else {
            this.getOfflineProduct();
          }
        });
      });
      this.mySubscription.unsubscribe();
      for (var i = 1; i <= 50; i++) {
        this.quantity.push(i);
      }
      this.userSrv.getShopLink().subscribe((res) => {
        this.currentUrl = this.router.url;
        this.router.events
          .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
          .subscribe((e: NavigationEnd) => {
            this.currentUrl = this.router.url;
            this.checkSpinTheWheelShow(this.router.url);
          });
        if (res === null || res === "") {
          this.categoryName = "";
        } else {
          this.categoryName = res;
        }
      });
      this.selectedStoreName = localStorage.getItem("localStoreName");
      this.isShown = false; //collect varient data
      this.showVariance = false;
    }
  }

  addOfflineProductToCart() {
    if (localStorage.getItem("cartProduct") !== null) {
      let offlineProduct = JSON.parse(localStorage.getItem("cartProduct"));
      let productArray = offlineProduct["product"];
      let obj = {
        storeId: offlineProduct["storeId"],
        cartProduct: productArray,
      };

      this.commonService.addOfflineProductInCart(obj).subscribe((res) => {
        localStorage.removeItem("cartProduct");
      });
    }
  }

  getCalled(id) {
    this.isStoreHours = id;
    const element = document.getElementById(id) as HTMLInputElement;
    if (element) {
      element.checked = true;
      element.click(); // Simulate a click on the radio button
    }
  }
  //--------onit end here----------------------------------------------------
  modalClose() {
    $("#storeHistoryModal").modal("hide");
  }
  getMarqueeData() {
    $("#maindiv").width($("#div1").width());
    let storeId = localStorage.getItem("localStoreId");
    this.commonService.getMarqueeData(storeId).subscribe((res: any) => {
      if (res?.data && res?.data?.length) {
        this.marqueeText = res?.data?.reverse();
        this.appStateSvc.setState({
          marqueeText: this.marqueeText,
        });
      }
    });
  }
  getColor() {
    this.siteDada = JSON.parse(localStorage.getItem("siteData"));
    let style: any;
    if (this.siteDada?.headerColor) {
      style = { background: this.siteDada?.headerColor, width: "100%" };
    } else {
      style = { background: "#000", width: "100%" };
    }
    return style;
  }

  getMarqueeColor() {
    let style: any;
    this.siteDada = JSON.parse(localStorage.getItem("siteData"));
    if (this.siteDada?.marqueeColor) {
      style = {
        background: this.siteDada?.marqueeColor,
        height: "38px",
      };
    } else {
      style = { background: "#000", height: "38px" };
    }
    return style;
  }

  openNavs() {
    this.isSideNav = !this.isSideNav;
  }

  getTextIconColor(sty, type?) {
    let style: any;
    this.siteDada = JSON?.parse(localStorage.getItem("siteData"));
    this.renderer?.setStyle(
      this.input?.nativeElement,
      "--placeholder-color",
      this.siteDada?.headerTextColor,
    );
    if (this.siteDada?.headerTextColor) {
      style = sty;
    } else {
      style = { color: "#fff" };
    }
    if (type == "subcat" && !this.siteDada?.headerTextColor) {
      style = { color: "#000" };
    }
    if (type == "subcatMobile" && !this.siteDada?.headerTextColor) {
      style = { color: "#fff" };
    }
    return style;
  }

  scrollToTop() {
    (function smoothscroll() {
      const currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    })();
  }

  getSuggestionSearchList() {
    this.commonService.getSuggestionSearchList().subscribe((res) => {
      this.suggestionSearchList = res["data"];
    });
  }

  logoFunction() {
    // this.getAddress();
  }

  //order api
  usercvvError;
  loginModeOn: Boolean = false;
  userExpiryrError;
  orderDetail;
  canShowThankyoupage: Boolean = false;

  hidecart() {
    if (this.auth) {
      $("#shoppingCart").modal("hide");
      this.canShowThankyoupage = false;
      this.showLoginStaffPick = true;
      this.loginModeOn = false;
    } else {
      $("#shoppingCart").modal("hide");
      this.canShowThankyoupage = false;
      this.loginModeOn = false;
      this.cartLength = 0;
      this.guestProgressbarWidth = "0%";
      localStorage.removeItem("cartProduct");
    }
  }

  cartLengthUpdate(number) {
    this.cartLength = number;
  }

  hoverindex;
  setshophoverindex(index) {
    this.hoverindex = index;
  }

  sortFuncForSubcat(a, b) {
    // const nameA = a.subCategoryName.toUpperCase(); // ignore upper and lowercase
    // const nameB = b.subCategoryName.toUpperCase(); // ignore upper and lowercase
    const nameA = a.subCategoryName; // ignore upper and lowercase
    const nameB = b.subCategoryName; // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  }
  actualId;
  isShown;
  varianceArray = [];
  showVariance;
  showVarianceList(array, catalogItemId) {
    this.actualId = catalogItemId;
    this.isShown = true; //collect varient data
    this.varianceArray = array;
    this.showVariance = true;
  }

  storeTime;

  checkValueInSearch() {
    this.activatedRoute.queryParams.subscribe((res) => {
      this.searchInput = res["search"];
    });
  }

  showModalPopup() {
    $("#mobileVerifyPopup").modal({
      show: false,
      backdrop: "static",
    });
    $("#SearchLocation").modal({
      show: false,
      backdrop: "static",
    });
    $("#dilveryNotAvailable").modal({
      show: false,
      backdrop: "static",
    });
  }

  hideLogoutPopUp() {
    $("#logoutPopUp").modal("hide");
  }

  logout() {
    this.hideLogoutPopUp();
    this.commonService.logoutUser("web").subscribe(
      (res) => {
        if (res["meta"]["status"]) {
          this.clearStoreage();
          this.router.navigateByUrl("/").then(() => {
            location.reload();
          });
        }
      },
      (error) => {
        if (error.status === 440 || error.status === 401) {
          this.clearStoreage();
          location.reload();
        }
      },
    );
  }
  clearStoreage() {
    localStorage.removeItem("userDetails");
    localStorage.removeItem("authorization");
    localStorage.removeItem("mobileVerified");
    localStorage.removeItem("userId");
    localStorage.removeItem("token");
    localStorage.removeItem("covaUserId");
    localStorage.removeItem("documentVerify");
    localStorage.removeItem("addressId");
    localStorage.removeItem("email");
    localStorage.removeItem("cartProduct");
    localStorage.removeItem("cartLimit");
    localStorage.removeItem("loggedInCart");
  }

  getAddress() {
    if (this.auth) {
      let covaid = localStorage.getItem("covaUserId");
      let obj = {
        CustomerId: covaid,
      };
      this.commonService.getUserLocation(obj).subscribe((res) => {
        if (res["meta"]["status"]) {
          let addressId = res["data"][0].Id;
          localStorage.setItem("addressId", addressId);
        } else {
          localStorage.removeItem("addressId");
        }
      });
    } else {
      this.addressString = localStorage.getItem("addressString");
    }
  }

  ngAfterViewInit() {
    this.userSrv.getStore().subscribe((res) => {
      if (res === null) {
        this.storeId = "";
        this.storeName = "";
      } else {
        this.storeId = Number(res["storeId"]);
        this.storeName = res["storeName"];
      }
    });
  }

  showLoginStaffPick: Boolean = false;
  recommendedProductsList;
  weightLimit;
  CompareWithSubTotal;
  CartSubTotal;
  CartBarLimit;
  logincartProduct;
  getCartProduct() {
    var isSwitchStatus = false;
    var storeID = localStorage.getItem("localStoreId");
    if (localStorage.getItem("isSwitch") == "true") {
      isSwitchStatus = true;
    } else {
      isSwitchStatus = false;
    }
    this.cartProduct$ = this.commonService
      .getUserCartProduct(isSwitchStatus, storeID)
      .subscribe((res: any) => {
        this.logincartProduct = res;
        if (res["meta"]["status"]) {
          localStorage.setItem("isSwitch", "false");
          this.weightLimit = res["wtSum"];
          let percentage = (this.weightLimit / this.CartBarLimit) * 100;

          if (res["minimumCartValuebyCity"]) {
            this.CompareWithSubTotal = res["minimumCartValuebyCity"].amount;
            this.CartSubTotal = Number(res["subTotal"]);
          }
          if (this.weightLimit) {
            this.progressbarWidth = String(percentage.toFixed(0)) + "%";
          } else {
            this.progressbarWidth = String(percentage.toFixed(0) + "%");
          }
          localStorage.setItem("cartLimit", this.weightLimit);
          this.recommendedProductsList = res["RecomendedProducts"];
          this.showLoginStaffPick = true;
          if (
            res["data"] &&
            res["data"]["addtoCart"] &&
            res["data"]["addtoCart"].length === 0
          ) {
            this.cartLength = 0;
            localStorage.setItem("loggedInCart", String(this.cartLength));
            this.commonService.updateCartProduct(0);
            this.cartSum = "$" + 0;
            this.cartMessageError = "";
            this.userSrv.updateCartMessage("");
          } else {
            this.cartLength = res["data"]["addtoCart"].length;
            localStorage.setItem("loggedInCart", String(this.cartLength));
            this.commonService.updateCartProduct(
              res["data"]["addtoCart"].length,
            );
            this.cartSum = "$" + Number(res.grandTotal).toFixed(2);
          }
        } else {
          this.cartLength = 0;
          this.weightLimit = 0;
          localStorage.setItem("cartLimit", this.weightLimit);
          localStorage.setItem("loggedInCart", String(this.cartLength));
          this.commonService.updateCartProduct(0);
          this.cartSum = "$" + 0;
          this.cartMessageError = "";
          this.userSrv.updateCartMessage("");
        }
      });
  }

  guestCartWeight;
  getOfflineProduct() {
    if (localStorage.getItem("cartProduct") === null) {
      this.cartLength = 0;
      this.guestProgressbarWidth = "0%";
      localStorage.removeItem("cartProduct");
    } else {
      let offlineProduct = JSON.parse(localStorage.getItem("cartProduct"));
      this.offlineCartProduct = offlineProduct["product"];
      //
      if (this.offlineCartProduct.length === 0) {
        localStorage.removeItem("cartProduct");
        this.guestProgressbarWidth = "0%";
        this.cartLength = 0;
      }

      this.cartLength = this.offlineCartProduct.length;
      let currentcartWeight = 0;
      offlineProduct["product"].forEach((cartPd) => {
        currentcartWeight = currentcartWeight + cartPd.weight * cartPd.quantity;
        this.guestCartWeight = Number(currentcartWeight);
      });

      //bar get
      let percentage = (currentcartWeight / this.CartBarLimit) * 100;
      if (currentcartWeight) {
        this.guestProgressbarWidth = String(percentage.toFixed(0)) + "%";
      } else {
        this.guestProgressbarWidth = String(percentage.toFixed(0) + "%");
      }
      localStorage.setItem("cartLimit", this.weightLimit);
      this.commonService.updateCartProduct(this.cartLength);
      this.updateCartCount(this.cartLength);
      //this.offlineCartProduct['product'].length
    }
  }

  openLogoutPopUp() {
    $("#logoutPopUp").modal("show");
  }

  currentOrderType: String = "";
  newOrderType: String = "";
  toChangeStatus;

  selectMailOrderFromHeader(status) {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("mySidenav").style.display = "none";

    document.getElementById("storeHistoryModal").style.display = "none";

    if (localStorage.getItem("isPickUpOrder") == status) {
      if (status === "true") {
        $("#SearchLocation").modal("show");
      } else {
      }
    } else {
      this.toChangeStatus = status;
      localStorage.setItem("toChangeStatus", status);
      if (localStorage.getItem("isPickUpOrder") == "false") {
        this.currentOrderType = "Delivery";
        this.newOrderType = "Pickup";
      } else {
        this.currentOrderType = "Pickup";
        this.newOrderType = "Delivery";
      }

      if (status === "true") {
        $("#SearchLocation").modal("show");
      }
    }
  }

  pickUpStatus;
  orderType;
  //add var. or not
  showMinusOrPlus: Boolean = false;
  showVarincePrice: Boolean = true;

  isSabCatVisible: Boolean = false;
  canichangethecategory: Boolean = true;
  redirectToShopPage(list) {
    this.categoryName = list.categoryName;
    let categoryNameWithId = list.categoryName + "_" + list.slug;
    this.appStateSvc.setState({
      page: 1,
    });
    if (this.categoryName === "New Arrivals") {
      this.router.navigateByUrl("/shop/NewArrivals");
      return;
    }
    if (this.categoryName === "All") {
      this.router.navigateByUrl("/shop");
      this.userSrv.updateShopLink("All");
    } else {
      this.router.navigateByUrl("/shop/" + categoryNameWithId);
    }
    // this.router.navigate(['/shop/Edibles_edibles'], {
    //   state: { myData: 'hello' }
    // });
    this.openSubCat(list);
  }
  redirectToShopPageForMobile(categoryName, categoryId) {
    this.categoryName = categoryName;
    let categoryNameWithId = categoryName + "_" + categoryId;
    if (this.categoryName === "All") {
      this.router.navigateByUrl("/shop");
      this.userSrv.updateShopLink("All");
    } else {
      this.router.navigateByUrl("/shop/" + categoryNameWithId);
      this.userSrv.updateShopLink(categoryNameWithId);
    }
  }
  redirectToShopPageWithSubCategoryId(list, category) {
    this.subCatClick = false;
    this.subCategoryName = list.subCategoryName;
    let subCategoryNameWithId = category?.slug + "_" + list.slug;
    this.subCatList = [];

    if (this.subCategoryName == "All Flowers") {
      this.categoryName = "Flower";
      let categoryNameWithId = "Flower_flower";
      this.router.navigateByUrl("/shop/" + categoryNameWithId);
      this.userSrv.updateShopLink(categoryNameWithId);
      return;
    }

    if (this.subCategoryName === "All") {
      this.router.navigateByUrl("/shop");
      this.userSrv.updateShopLink("All");
    } else {
      this.router.navigateByUrl("/shop/subProduct/" + subCategoryNameWithId);
    }
  }

  redirectToShopPage1() {
    this.router.navigateByUrl("/shop/all");
  }

  checkUserEmailIDStatus() {
    this.userSrv.getAuth().subscribe((res) => {
      if (res) {
        this.userSrv.getUserAddedFromCSV().subscribe((x) => {
          if (x !== null) {
            if (x.userStatus === true) {
              if (x.emailVerified === false) {
                this.router.navigateByUrl("/verify/verify-email");
              } else {
                this.router.navigateByUrl("/verify/change-password");
              }
            }
          }
        });
      }
    });
  }

  newStoreHoursFormat(hour, min) {
    var newFormatedValue = hour + ":" + min;
    return moment(newFormatedValue, ["HH:mm"]).format("h:mm A");
  }

  saveUserAddressAfterLogin() {
    let addressData = JSON.parse(localStorage.getItem("addressData"));
    this.getAddressFromLocalStorage(
      addressData.name,
      addressData.address_components,
      addressData.geometry.location,
      addressData.formatted_address,
    );
  }

  getAddressFromLocalStorage(
    streetName,
    addressComponents,
    geometry,
    formattedAddress,
  ) {
    this.addressCurrentLat = geometry.lat;
    this.addressCurrentLong = geometry.lng;
    this.addressFormattedAddress = formattedAddress;
    this.addressStreetNumber = streetName;
    addressComponents.map((item) => {
      item.types.map((data) => {
        if (data === "postal_code") {
          this.addressPostalCode = item.long_name;
        } else if (data === "neighborhood") {
          this.addressNeighborhood = item.long_name;
        } else if (data === "locality") {
          this.addressLocality = item.long_name;
        } else if (data === "administrative_area_level_1") {
          this.addressAdministrationLevel = item.short_name;
        } else if (data === "country") {
          this.addressCountry = item.long_name;
        } else if (data === "route") {
          this.addressRoute = item.long_name;
        }
      });
    });
  }

  createSpinnerForm() {
    this.spinnerForm = this.fb.group({
      firstName: ["", Validators.required],
      emailId: ["", [Validators.required, Validators.email]],
    });
  }

  dateArray = [];
  getDateArrayPickup() {
    this.dateArray = [];

    for (var i = 0; i <= 1; i++) {
      let date;
      let days;
      let milliSecond;
      if (i === 0) {
        days = moment.tz("America/Los_Angeles").format("dddd");
        date = moment.tz("America/Los_Angeles").format("YYYY-MM-DD");
        milliSecond = moment
          .tz(date, "America/Los_Angeles")
          .startOf("day")
          .valueOf();
        this.dateArray.push({
          date: date,
          day: days,
          milliSecond: milliSecond,
          same: 0,
        });
      } else {
        days = moment.tz("America/Los_Angeles").add(i, "days").format("dddd");
        date = moment
          .tz("America/Los_Angeles")
          .add(i, "days")
          .format("YYYY-MM-DD");
        milliSecond = moment
          .tz(date, "America/Los_Angeles")
          .startOf("day")
          .valueOf();
        this.dateArray.push({
          date: date,
          day: days,
          same: 1,
          milliSecond: milliSecond,
        });
      }
    }
    this.selectedDate = this.dateArray[0].date;
  }

  userCreditcardError;

  suggList: Boolean = false;
  tapOnSearchBar(event) {
    event.stopPropagation();
    this.suggList = true;
  }

  searchProduct(value) {
    let d1: any;
    this.suggList = false;
    if (value === "") {
      this.router.navigateByUrl(`/shop/all`).then(() => {
        window.location.reload();
      });
    } else if (value == "allflowers") {
      this.router.navigateByUrl(`/shop/Flower_flower`);
    } else if (value == "alledibles") {
      this.router.navigateByUrl(`/shop/Edibles_edibles`);
    } else if (value == "newarrivals") {
      this.router.navigateByUrl(`/shop/NewArrivals`);
    } else if (value == "deals") {
      this.router.navigateByUrl(`/shop/deals`);
    } else {
      d1 = value?.replaceAll(/ /g, " ");
      this.router.navigateByUrl(`/shop/all?search=${d1}`);
    }
    this.bs.setSearch(d1);
    this.topSearchArray = [];
    this.search_suggestionArr = [];
    this.isSearchShow = false;
    this.hideSearchDiv();
  }

  hidesearchSuggest() {}

  out() {
    this.searchIn = false;
    this.showNoResult = false;
    this.suggList = false;
  }

  @HostListener("document:click", ["$event"]) onDocumentClick() {
    this.searchIn = false;
    this.showNoResult = false;
    this.suggList = false;
  }

  @HostListener("document:keypress", ["$event"]) onDocumentKeypree() {
    this.suggList = false;
  }
  stopPendingRequest() {
    if (this.subscriptions?.length > 0) {
      this.subscriptions?.map((subscription, i) => {
        subscription?.unsubscribe();
        this.subscriptions = [];
      });
    }
  }

  searchIn: boolean = false;
  showNoResult: boolean = false;
  search_suggestionArr;
  searchSuggest(event) {
    this.stopPendingRequest();
    event.stopPropagation();
    let searchValue = event.target.value;
    if (searchValue == "") {
      this.topSearchArray = [];
    }
    this.showNoResult = false;
    this.suggList = true;
    if (searchValue?.length == 0) {
      this.searchIn = false;
      this.showNoResult = false;
      return (this.search_suggestionArr = []);
    }
    if (this.suggestionSearchList?.length) {
      this.topSearchArray = [];
      this.topSearchArray = this.suggestionSearchList.filter((res) =>
        res?.name?.toLowerCase().includes(searchValue.toLowerCase()),
      );
      if (this.topSearchArray?.length == 0) {
        if (searchValue.length >= 2) {
          let obj = {
            storeId: Number(localStorage.getItem("localStoreId")),
            searchKey: searchValue,
            resPerPage: 10,
            page: 1,
          };
          let product: any = this.commonService
            .searchSingleProductnew(obj)
            .subscribe((res) => {
              if (res["data"]) {
                if (res["data"].length) {
                  this.searchIn = true;
                  this.search_suggestionArr = res["data"];
                } else {
                  this.search_suggestionArr = [];
                  this.showNoResult = true;
                  this.searchIn = false;
                }
              } else {
                this.showNoResult = true;
                this.searchIn = false;
                this.search_suggestionArr = [];
              }
            });
          this.subscriptions.push(product);
        }
      }
    }
  }

  hideSearchDiv() {
    this.searchIn = false;
    this.isSearchShow = false;
    this.searchInput = "";
  }

  getDefaultStore() {
    if (
      localStorage.getItem("storeDefault") === null ||
      localStorage.getItem("storeDefault") === undefined
    ) {
      this.commonService.defaultStore().subscribe((res) => {
        localStorage.setItem("localStoreId", res["storeId"]);
        localStorage.setItem("localStoreName", res["storeName"]);
        localStorage.setItem("storeAccountNum", res["storeAccountNum"]);
        localStorage.setItem("authorization", res["authorization"]);
        localStorage.setItem("storeDefault", "default");
        this.userSrv.updateStoreDetails(res);
        // $("#SearchLocation").modal("hide");
      });
    }
  }

  checkSpinTheWheelShow(url) {
    if (url.includes("checkout")) {
      $("#spinTheWheel").addClass("displayNoneSpinTheWheel");
    } else {
      $("#spinTheWheel").removeClass("displayNoneSpinTheWheel");
    }
  }

  getSortedCategoryList(list) {
    //  return list.sort(this.getSortOrder("sort"));
    let array = list.sort(this.getSortOrder("sort"));
    return array;
  }

  getSortOrder(prop) {
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1;
      } else if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    };
  }

  openSearchModal() {
    $("#searchAddressInput").val(this.addressString);
  }

  storeMobileNumber;
  getStoreMobileNumber(number) {
    if (!number) {
      return this.storeMobile;
    } else {
      let splitNumber1 = number.toString().substring(0, 3);
      let splitNumber2 = number.toString().substring(3, 6);
      let splitNumber3 = number.toString().substring(6, 10);
      let updateNumber =
        "(" + splitNumber1 + ") " + splitNumber2 + "-" + splitNumber3;
      return updateNumber;
    }
  }
  onHover() {
    if (screen.width < 600) {
      return false;
    } else {
      return true;
    }
  }
  speed: any = "";
  onSpeed() {
    if (screen.width < 600) {
      return "30s";
    } else {
      return "30s";
    }
  }

  redirectToShopPageList() {
    this.router.navigateByUrl("/shop/all");
  }

  redirectToPickupDetailPage() {
    $("#SearchLocation").modal("hide");
    $("#storeHistoryModal").modal("hide");
    this.router.navigateByUrl("/pickup-detail");
  }

  dilverytime;
  dilveryHoursObj;
  getStoreDetail() {
    const obj = {
      Id: Number(localStorage.getItem("localStoreId")),
    };
    this.commonService.getStoreDetail(obj).subscribe((res) => {
      this.storeDetails = res["data"];
      this.storeMobileNumber = res["data"];
      let weekday = new Date().toLocaleString("en-us", { weekday: "long" });
      if (this.storeDetails && this.storeDetails["StoreHours"]) {
        let a = this.storeDetails["StoreHours"][weekday];
        let dilveryHoursObj = this.storeDetails["DeliveryHours"][weekday];
        var currentTime = moment(new Date());
        var StoreOpenTime = a.Open.Hour + ":" + a.Open.Minute;
        var StoreCloseTime = a.Close.Hour + ":" + a.Close.Minute;
        var endTime: any;
        var beginningTime = moment(StoreOpenTime, "HH:mm");
        if (StoreCloseTime == "0:0") {
          StoreCloseTime = "24:0";
        }
        if (a.Close.Hour < a.Open.Hour && a.Close.Hour != "0") {
          endTime = moment(StoreCloseTime, "HH:mm").add(1, "day");
        } else {
          endTime = moment(StoreCloseTime, "HH:mm");
        }

        if (currentTime > beginningTime && currentTime < endTime) {
          this.StoreClosed = false;
        } else {
          this.StoreClosed = true;
        }
        if (a) {
          this.storeTime = a;
          this.dilverytime = dilveryHoursObj;
          localStorage.setItem("storeTiming", JSON.stringify(a));
        }
      }
    });
  }

  modalOpen() {
    $("#storeHistoryModal").modal("show");
  }

  pickUpStoreList: any = [];
  CurrentStoreData;
  getStoreList() {
    this.commonService.pickUpStore("").subscribe((res) => {
      this.pickUpStoreList = res;
      let currentstoreid = Number(localStorage.getItem("localStoreId"));
      this.CurrentStoreData = this.pickUpStoreList?.find(
        (a) => a?.Id == currentstoreid,
      );
      var coordinates_array = [];
      let lat2: number;
      let lon2: number;
      for (let i = 0; i < res.length; i++) {
        coordinates_array.push(this.pickUpStoreList[i]?.coordinates);
        lat2 = coordinates_array?.[i]?.[0];
        lon2 = coordinates_array?.[i]?.[1];
      }
      this.saveSortingResultDistance();
    });
  }

  saveSortingResultDistance() {
    let a = this.pickUpStoreList.sort((a, b) => {
      return a?.distanceInKms - b?.distanceInKms;
    });
  }

  getStoreMObile() {
    let currentstoreid = Number(localStorage.getItem("localStoreId"));
    let mno: any = this.pickUpStoreList?.find(
      (a) => a?.Id == currentstoreid,
    )?.storeMobile;
    return mno;
  }
  
  storeOpenCloseTimeing1() {
    $("#storeOpenCloseTimeing").modal("hide");
  }
  storeOpenCloseTimeing(Name) {
    this.selectedStoreName = Name;
    $("#storeOpenCloseTimeing").modal("show");
  }
  hideSidenav_user() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("mySidenav").style.display = "none";
  }
  openMapModal() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("mySidenav").style.display = "none";
    $("#SearchLocation").modal("show"); //map modal
  }

  openRegister() {
    document.getElementById("mySideLogin").style.width = "0";
    document.getElementById("mySideRegister").style.width = "450px";
    function myFunction(x) {
      if (x.matches) {
        document.getElementById("mySideRegister").style.width = "calc(100%)";
      }
    }

    var x = window.matchMedia("(max-width: 580px)");
    myFunction(x);
    x.addEventListener("click", myFunction); // Attach listener function on state changes
    const modal = document.getElementById("mySideRegister");
    modal.focus();
  }

  getSideNavCOntent() {
    this.commonService.getHOmeContent().subscribe((res) => {
      if (res["meta"]["status"]) {
        this.sideMenu = res["data"]["sideNavButton"];
        sessionStorage.setItem(
          "sideMenu",
          JSON.stringify(res["data"]["sideNavButton"]),
        );
        this.sideMenu = JSON.parse(sessionStorage.getItem("sideMenu"));
        if (res["data"]?.contactPage) {
          sessionStorage.setItem(
            "contactData",
            JSON.stringify(res["data"]["contactPage"]),
          );
        }
      }
    });
  }

  routeToUrls(url, item) {
    if (url == "" || url == undefined) {
      if (item?.title == "Shop") {
        return "shop/all";
      }
      if (item?.title == "PRESS") {
        return "press";
      } else if (item?.title == "Brands") {
        return "brand/list";
      } else if (item?.title == "Deals") {
        return "shop/deals";
      } else if (item?.title == "Contact Us") {
        return "contact-us";
      } else if (item?.title == "Flower") {
        return "shop/Flower_flower";
      } else if (item?.title == "What's New") {
        return "shop/NewArrivals";
      } else if (item?.title == "CBD") {
        return "shop/CBD_cbd";
      } else if (item?.title == "Accessories") {
        return "shop/Accessories_accessories";
      } else if (item?.title == "Edibles") {
        return "shop/Edibles_edibles";
      } else if (item?.title == "Concentrates") {
        return "shop/Concentrates_concentrates";
      } else if (item?.title == "Vapourizers") {
        return "shop/Vapourizers_vapourizers";
      } else if (item?.title == "About Us") {
        return "about-us";
      } else if (item?.title == "High THC") {
        return "shop/high-thc";
      } else if (item?.title == "Pre Rolls") {
        return "shop/Pre-roll_pre-roll";
      } else if (item?.title == "Stores") {
        return "verify/age";
      }
    } else {
      return url;
    }
  }

  closeStoreTimeModal2() {
    $("#storeOpenCloseTimeing2").modal("hide");
  }

  manageOrderOption(type: any) {
    return this.storeDetails?.services.some((s) => s.includes(type));
  }
  openStoreTimeModal3() {
    this.openNavs();
    this.showLoading = true;

    setTimeout(() => {
      $("#storeOpenCloseTimeing2").modal("show");
      this.getData();
    }, 200);
  }

  getData() {
    let obj = {
      Id: localStorage.getItem("localStoreId"),
    };
    this.commonService.getStoreDetail(obj).subscribe((res) => {
      let a = res["data"];
      this.storeAddresss = a?.Address?.AddressLine2;
      this.storeMobileNumber = a?.storeMobile;
      this.showLoading = false;
    });
  }
  getSideNavColor() {
    this.siteDada = JSON.parse(localStorage.getItem("siteData"));
    let style: any;
    if (this.siteDada?.sideMenuColor) {
      style = { background: this.siteDada?.sideMenuColor };
    } else {
      style = { background: "#000" };
    }

    if (this.isSideNav) {
      style["display"] = "block";
      document.getElementById("mySidenav").style.width = "350px";
      document.getElementById("mySidenav").style.display = "block";

      function myFunction(x) {
        if (x.matches) {
          document.getElementById("mySidenav").style.width = "calc(100%)";
        }
      }

      var x = window.matchMedia("(max-width: 580px)");
      myFunction(x);
      x.addListener(myFunction);
      const modal = document.getElementById("mySidenav");
      modal.focus();
    } else {
      style["display"] = "none";
    }
    return style;
  }
  addressValue(address) {
    return address?.AddressLine2;
    // return address?.AddressLine1 ? address?.AddressLine1 :''+ ", " + address?.City ? address?.City:'' + ", " + address?.StateName ? address?.StateName:'' + ", " + address?.CountryCode ? address?.CountryCode:'' + ", " + address?.Zip ? address?.Zip:'';
    // }
  }

  manageOrderOptions(type: any) {
    if (
      this.storeDetails?.services.some((s) => s.includes(type)) &&
      type == "Delivery"
    ) {
      return "Delivery ";
    }

    if (
      this.storeDetails?.services.some((s) => s.includes(type)) &&
      type == "Pickup"
    ) {
      return " Store  Pickup ";
    }

    if (
      this.storeDetails?.services.some((s) => s.includes(type)) &&
      type == "CurbsidePickup"
    ) {
      return " Curbside Pickup";
    }

    return;
  }

  manageStoreTIme(type: any) {
    if (
      this.storeDetails?.services.some((s) => s.includes(type)) &&
      type == "Delivery"
    ) {
      return true;
    }

    if (
      this.storeDetails?.services.some((s) => s.includes(type)) &&
      type == "Pickup"
    ) {
      return true;
    }

    return;
  }
  openMobileVerify() {
    document.getElementById("mySideLogin").style.width = "0";
    document.getElementById("mySideRegister").style.width = "0";
    document.getElementById("mySideMobileVerify").style.width = "450px";
    function myFunction(x) {
      if (x.matches) {
        document.getElementById("mySideMobileVerify").style.width =
          "calc(100%)";
      }
    }

    var x = window.matchMedia("(max-width: 580px)");
    myFunction(x);
    x.addEventListener("click", myFunction); // Attach listener function on state changes
    const modal = document.getElementById("mySideRegister");
    modal.focus();
  }

  subCatClick: boolean = true;
  openSubCat(item) {
    this.subCatClick = true;
    this.subCategoryMobile = item;
    if (item?.subCategory == undefined || item?.subCategory?.length == 0) {
      this.subCatList = [];
      this.redirectToShopPageForMobile(item?.categoryName, item?.slug);
    } else {
      if (this.subCatList == item?.subCategory) {
        this.subCatList = [];
      } else {
        this.subCatList = item?.subCategory;
      }
    }
  }
}

export interface Search {
  img: string;
  name: string;
}


